import { Box, Flex, Text } from "@chakra-ui/react";
import { Center } from "../types/center.types";
import Card from "./Card";
import { useCenter } from "../hooks/centers.hooks";
import { useAddress } from "../hooks/address.hooks";

const CenterCard = ({ center }: { center?: Center }) => {
  const { data: refreshedCenter } = useCenter(center?.id);
  const { data: billingAddress } = useAddress(
    refreshedCenter?.enterprise?.addressId
  );
  const { data: shippingAddress } = useAddress(
    refreshedCenter?.shippingAddressId
  );

  return (
    <Card w="100%">
      <Flex
        borderTopRadius="xl"
        py={2}
        borderBottom="solid 1px"
        borderColor="gray.200"
        w="100%"
        direction="column"
      >
        <Box borderBottom="solid 1px" borderColor="gray.200">
          <Text
            lineHeight="21px"
            fontSize="16px"
            fontWeight="600"
            px={4}
            py={4}
          >
            {center && center.name}
          </Text>
        </Box>

        <Flex direction="column" px={4} mt={4} gap={2}>
            <Flex direction="column">
                <Text lineHeight='21px' fontSize='16px' fontWeight='600'>Adresse de facturation</Text>
                <Text>{refreshedCenter?.enterprise?.name}</Text>
                <Text>{billingAddress?.streetNumber}{' '}{billingAddress?.streetName}</Text>
                <Text>{billingAddress?.postalCode}{' '}{billingAddress?.city}</Text>
            </Flex>

            <Box my={2} borderBottom="solid 1px" borderColor="gray.200" />

            <Flex direction="column">
                <Text lineHeight='21px' fontSize='16px' fontWeight='600'>Adresse de livraison</Text>
                <Text>{refreshedCenter?.name}</Text>
                <Text>{shippingAddress?.streetNumber}{' '}{shippingAddress?.streetName}</Text>
                <Text>{shippingAddress?.postalCode}{' '}{shippingAddress?.city}</Text>
            </Flex>
          </Flex>
      </Flex>
    </Card>
  );
};

export default CenterCard;
